export default __webpack_public_path__ + "static/media/05_photo.e2c7a2fc.jpg";